module.exports = __webpack_public_path__ + "static/media/131.c286584f.png";